import logo from "./img/Nu Kenzie.svg";
import "./Styles/styles.css";

export const Header = ({ setIsLogged }) => {
  return (
    <header className="container-header">
      <div className="header">
        <img src={logo} alt="logo" />
        <button onClick={() => setIsLogged(false)} className="header-button">
          Início
        </button>
      </div>
    </header>
  );
};
